import { render, staticRenderFns } from "./TypeIncome.vue?vue&type=template&id=6f68a598&"
import script from "./TypeIncome.vue?vue&type=script&lang=js&"
export * from "./TypeIncome.vue?vue&type=script&lang=js&"
import style0 from "./TypeIncome.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports